import { enUS } from 'date-fns/locale';
const dateEnUs = {
  name: 'en-US',
  locale: enUS
};
export default dateEnUs;